/* SystemsPartnersStrip — "We deliver on the platforms enterprises depend on".
 *
 * Honest framing: ZHELTA Systems is platform-agnostic but specialises in
 * these vendor stacks. Wordmarks rendered as styled text (no licensed
 * logos). Each chip clicks through to /systems/solutions so traffic from
 * branded searches has a relevant landing destination. */
import React from 'react';
import { Link } from 'react-router-dom';

const PARTNERS = [
  { label: 'Microsoft 365',  href: '/systems/solutions', sub: 'Email · Teams · Defender' },
  { label: 'aws',            href: '/systems/solutions', sub: 'EC2 · RDS · IAM',           mono: true },
  { label: 'Azure',          href: '/systems/solutions', sub: 'AD · Sentinel · Entra' },
  { label: 'Google Cloud',   href: '/systems/solutions', sub: 'Workspace · GCP' },
  { label: 'cisco',          href: '/systems/solutions', sub: 'Meraki · Umbrella',         mono: true },
  { label: 'VMware',         href: '/systems/solutions', sub: 'vSphere · Workspace ONE' },
];

export default function SystemsPartnersStrip() {
  return (
    <section
      data-testid="systems-partners-strip"
      className="relative bg-white border-y border-[#F0EDE5] py-10 md:py-12"
    >
      <div className="zh-container">
        <div className="text-center mb-7">
          <span className="text-[10.5px] font-bold uppercase tracking-[0.28em] text-[#a8871a]">
            We deliver on the platforms enterprises depend on
          </span>
        </div>
        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 items-stretch gap-3 sm:gap-4">
          {PARTNERS.map((p) => (
            <li key={p.label}>
              <Link
                to={p.href}
                data-testid={`systems-partner-${p.label.toLowerCase().replace(/\s+/g, '-')}`}
                className="group block h-full rounded-xl border border-[#E5E5E7] bg-white px-3 py-3 text-center transition-all duration-300 hover:border-[#c9a227] hover:bg-[#fff8e7] hover:shadow-[0_8px_20px_-12px_rgba(201,162,39,0.45)]"
              >
                <div
                  className={`text-[18px] sm:text-[19px] font-extrabold tracking-tight text-[#9aa0a6] group-hover:text-[#0e0e10] transition-colors leading-none
                    ${p.mono ? 'lowercase' : ''}`}
                >
                  {p.label}
                </div>
                <div className="mt-1.5 text-[10.5px] uppercase tracking-[0.18em] text-[#9aa0a6] group-hover:text-[#a8871a] transition-colors font-semibold">
                  {p.sub}
                </div>
              </Link>
            </li>
          ))}
        </ul>
        <p className="mt-6 text-center text-[11px] text-[#9aa0a6] max-w-[640px] mx-auto leading-relaxed">
          ZHELTA Systems is vendor-neutral. Logos are property of their respective owners; we are not affiliated unless explicitly stated.
        </p>
      </div>
    </section>
  );
}
